import type { StyleProps } from '@chakra-ui/react'

// eslint-disable-next-line local/enforce-shw-link
import type { ShwLinkProps } from '@/components/ShwLink'

import AuthLink from './AuthLink'

/**
 * @deprecated Use AuthLink component with mode="login" instead
 */
export default function LoginLink({
  href = null,
  children,
  width,
  ...props
}: {
  href?: string | null
  children: React.ReactNode
  width?: StyleProps['width']
} & Omit<ShwLinkProps, 'href'>): JSX.Element {
  return (
    <AuthLink mode="login" returnTo={href} width={width} {...props}>
      {children}
    </AuthLink>
  )
}
